import { useSelector } from 'react-redux'
import { authSelector } from '@/state/auth/slices/index.slices'
import { RoleType } from '@/enums/role.enum'

export type PopoverPlaceholder = {
  open: boolean
  element: null | HTMLElement
}

const useHasAccess = () => {
  const { userSession } = useSelector(authSelector)

  const hasAccess = (role: RoleType) => {
    return role === userSession.role
  }

  return {
    userSession,
    hasAccess,
  }
}

export default useHasAccess
